/**
 * Copyright © 2025-2026 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { Navigate, RouteObject } from "react-router-dom";

import { CardPartnerDirectoryPage } from "./CardPartnerDirectoryPage";
import { CARD_PARTNER_DIRECTORY_ROUTES } from "./constants";

export const cardPartnerDirectoryRoutes: RouteObject[] = [
  {
    path: CARD_PARTNER_DIRECTORY_ROUTES.ROOT,
    children: [
      { index: true, element: <CardPartnerDirectoryPage /> },
      { path: "*", element: <Navigate to={CARD_PARTNER_DIRECTORY_ROUTES.BASE} replace /> },
    ],
  },
];
